const STORAGE_KEY = 'insights:shell-enabled';

/** Optional build-time default for local dev (REACT_APP_INSIGHTS_SHELL=1 in .env.local). */
export const getShellEnvDefault = () => process.env.REACT_APP_INSIGHTS_SHELL === '1';

export const readShellEnabled = () => {
    if (typeof window !== 'undefined') {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (stored === '0') {
            return false;
        }
        if (stored === '1') {
            return true;
        }
    }
    return getShellEnvDefault();
};

export const setShellEnabled = (enabled) => {
    if (typeof window === 'undefined') {
        return;
    }
    window.localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
};

export const toggleShellLayoutAndReload = (_event, enabled) => {
    setShellEnabled(enabled !== undefined ? Boolean(enabled) : !readShellEnabled());
    window.location.reload();
};

export const disableShellAndReload = () => {
    setShellEnabled(false);
    window.location.reload();
};
